import {AbstractControl, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Observable} from 'rxjs';
import {startWith} from 'rxjs/operators';

export class ReactiveFormHelper {
  static get = (form: UntypedFormGroup, name: string): AbstractControl => getCtrl(form, name);

  static getValue = (form: UntypedFormGroup, name: string): unknown => getCtrl(form, name).value;

  static setValue = (form: UntypedFormGroup, name: string, value: unknown, shouldUpdate = true) => {
    const ctrl = getCtrl(form, name);

    if (shouldUpdate) {
      ctrl.setValue(value);
    }
  }

  static enableOrDisableCtrl = (form: UntypedFormGroup, name: string, disable: boolean) => {
    const ctrl = getCtrl(form, name);

    disable ? ctrl.disable() : ctrl.enable();
  }

  static getObsWithInitial = (form: UntypedFormGroup, name: string): Observable<unknown> => ReactiveFormHelper
    .get(form, name).valueChanges
    .pipe(startWith(ReactiveFormHelper.getValue(form, name)))

  static validateAllFormFields(formGroup: UntypedFormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({onlySelf: true});
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }
}

const getCtrl = (form: UntypedFormGroup, name: string): AbstractControl => {
  if (!form || !name) {
    throw Error('Form or name is missing form:' + form + ' name:' + name);
  }
  const ctrl = form.get(name);
  if (!ctrl) {
    throw Error('Ctrl is not available. form:' + form + ' name: ' + name);
  }
  return ctrl;
};
